<template>
  <div :breadcrumb="false">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'PageView'
}
</script>
